const API_BASE = '/api';

async function fetchApi(endpoint, options = {}) {
  const url = `${API_BASE}${endpoint}`;
  const { headers: optionHeaders, ...restOptions } = options;
  const response = await fetch(url, {
    ...restOptions,
    headers: {
      'Content-Type': 'application/json',
      ...optionHeaders,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'An error occurred');
  }

  return data;
}

function authHeader(token) {
  return token ? { Authorization: `Bearer ${token}` } : {};
}

// Auth endpoints
export async function login(email, password) {
  return fetchApi('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
}

export async function register(email, password, displayName, gender, preferredLanguage) {
  return fetchApi('/auth/register', {
    method: 'POST',
    body: JSON.stringify({ email, password, displayName, gender, preferredLanguage }),
  });
}

export async function getProfile(token) {
  return fetchApi('/auth/profile', {
    headers: authHeader(token),
  });
}

export async function updateProfile(updates, token) {
  return fetchApi('/auth/profile', {
    method: 'PUT',
    headers: authHeader(token),
    body: JSON.stringify(updates),
  });
}

// Meeting endpoints
export async function createMeeting(data, token) {
  // Support both old API (title only) and new API (full object)
  const body = typeof data === 'string'
    ? { title: data }
    : data;

  return fetchApi('/meetings', {
    method: 'POST',
    headers: authHeader(token),
    body: JSON.stringify(body),
  });
}

export async function getMeeting(code, token = null) {
  return fetchApi(`/meetings/${code}`, {
    headers: authHeader(token),
  });
}

export async function getUserMeetings(token) {
  return fetchApi('/meetings/my-meetings', {
    headers: authHeader(token),
  });
}

export async function updateMeetingSettings(code, settings, token) {
  return fetchApi(`/meetings/${code}/settings`, {
    method: 'PUT',
    headers: authHeader(token),
    body: JSON.stringify({ settings }),
  });
}

export async function endMeeting(code, token) {
  return fetchApi(`/meetings/${code}/end`, {
    method: 'POST',
    headers: authHeader(token),
  });
}

// Invite endpoints
export async function getInvites(code, token) {
  return fetchApi(`/meetings/${code}/invites`, {
    headers: authHeader(token),
  });
}

export async function addInvitees(code, invitees, sendNow, token) {
  return fetchApi(`/meetings/${code}/invites`, {
    method: 'POST',
    headers: authHeader(token),
    body: JSON.stringify({ invitees, sendNow }),
  });
}

export async function sendInvites(code, inviteIds, token) {
  return fetchApi(`/meetings/${code}/invites/send`, {
    method: 'POST',
    headers: authHeader(token),
    body: JSON.stringify({ inviteIds }),
  });
}

export async function deleteInvite(code, inviteId, token) {
  return fetchApi(`/meetings/${code}/invites/${inviteId}`, {
    method: 'DELETE',
    headers: authHeader(token),
  });
}

export async function rescheduleMeeting(code, data, token) {
  return fetchApi(`/meetings/${code}/reschedule`, {
    method: 'PUT',
    headers: authHeader(token),
    body: JSON.stringify(data),
  });
}

// Other endpoints
export async function getLanguages() {
  return fetchApi('/languages');
}

// Video preferences
export async function getVideoPreferences(token) {
  return fetchApi('/auth/video-preferences', {
    headers: authHeader(token),
  });
}

export async function updateVideoPreferences(preferences, token) {
  return fetchApi('/auth/video-preferences', {
    method: 'PUT',
    headers: authHeader(token),
    body: JSON.stringify(preferences),
  });
}
